import { render, staticRenderFns } from "./addCustomerRoom.vue?vue&type=template&id=bd4ec678&scoped=true&"
import script from "./addCustomerRoom.vue?vue&type=script&lang=js&"
export * from "./addCustomerRoom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4ec678",
  null
  
)

export default component.exports